import { Section, Text } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

type Props = {
  requestDeadlineDay: number
}

const ClosureDaySetting = ({ requestDeadlineDay }: Props) => {
  const options = Array.from({ length: 28 }, (_, i) => ({
    label: i18n.t('salary_advance.settings.closure_day.day_of_each_month', { day: i + 1 }),
    value: i + 1,
  }))

  return (
    <Section.Form
      illustration="clock-app"
      title={i18n.t('salary_advance.settings.closure_day.title')}
      description={i18n.t('salary_advance.settings.closure_day.description')}
      isDirty={false}
      disabled
    >
      <Text.Normal weight="semibold" size="200">
        {i18n.t('salary_advance.settings.closure_day.date')}
      </Text.Normal>
      {/* Currently read-only. In the future, users will be able to change the closure day */}
      <Select
        none={i18n.t('common.select')}
        value={String(requestDeadlineDay)}
        onChange={() => {}}
        options={options}
        missingLabel={i18n.t('common.missing_field')}
        readonly
      />
    </Section.Form>
  )
}

export default ClosureDaySetting
